(function () {
  var el = document.querySelector('[data-landing]');
  if (!el) return;

  var siteHeader = document.getElementById('FSiteHeader');

  // Already seen this session (or reduced motion): layout/theme.liquid has put `f-intro-done` on <html>
  // before first paint, CSS hides the overlay and shows the header. Nothing to run.
  if (document.documentElement.classList.contains('f-intro-done')) {
    if (siteHeader) siteHeader.classList.add('is-visible');
    return;
  }

  var GROW_SCALE = 2;
  var TRAVEL_SCALE = 0.5;

  function positionO() {
    var oEl = document.querySelector('.f-landing-o');
    var hamburger = document.getElementById('FNavToggle');
    if (!oEl || !hamburger) return;

    var rect = oEl.getBoundingClientRect();
    var oCenterX = rect.left + rect.width / 2;
    var oCenterY = rect.top + rect.height / 2;

    // Stage 1 (45% of animation): grow to viewport center.
    var stage1X = (window.innerWidth / 2 - oCenterX) / GROW_SCALE;
    var stage1Y = (window.innerHeight / 2 - oCenterY) / GROW_SCALE;
    oEl.style.setProperty('--o-target-x', stage1X.toFixed(1) + 'px');
    oEl.style.setProperty('--o-target-y', stage1Y.toFixed(1) + 'px');

    // Stage 2 (100%): shrink + travel to the hamburger's position, becoming it.
    var hRect = hamburger.getBoundingClientRect();
    var hCenterX = hRect.left + hRect.width / 2;
    var hCenterY = hRect.top + hRect.height / 2;
    var stage2X = (hCenterX - oCenterX) / TRAVEL_SCALE;
    var stage2Y = (hCenterY - oCenterY) / TRAVEL_SCALE;
    oEl.style.setProperty('--o-target-x2', stage2X.toFixed(1) + 'px');
    oEl.style.setProperty('--o-target-y2', stage2Y.toFixed(1) + 'px');
  }

  // Every timer of the sequence goes through here so a click / key press can cancel the rest and jump to the end.
  var timers = [];
  function later(fn, ms) { if (finished) return; timers.push(setTimeout(fn, ms)); }
  var finished = false;
  function skip() {
    if (finished) return;
    finished = true;
    timers.forEach(clearTimeout);
    document.removeEventListener('click', skip, true);
    document.removeEventListener('keydown', skip, true);
    el.classList.add('is-skipping');
    if (siteHeader) siteHeader.classList.add('is-visible');
    setTimeout(function () { el.style.display = 'none'; }, 280);
  }
  document.addEventListener('click', skip, true);
  document.addEventListener('keydown', skip, true);

  function whenFontsReady(cb) {
    if (!document.fonts || !document.fonts.ready) {
      setTimeout(cb, 300);
      return;
    }
    var settled = false;
    function done() {
      if (settled) return;
      settled = true;
      cb();
    }
    document.fonts.load('44px Michroma').then(done).catch(done);
    document.fonts.ready.then(done);
    setTimeout(done, 1500);
  }

  function runSequence() {
    later(function () {
      positionO();
      el.classList.add('is-collapsing');
    }, 1900);

    // Reveal the header slightly before the O finishes traveling (its own
    // .6s fade-in completes right as the O arrives), so the hamburger's
    // icon/backdrop is already visible for the O to land into — otherwise
    // it looks like it's flying into empty space instead of a real icon.
    later(function () {
      if (siteHeader) siteHeader.classList.add('is-visible');
    }, 3900);

    // O finishes arriving at the hamburger ~2.6s after is-collapsing starts (1900 + 2600).
    later(function () {
      el.classList.add('show-cta');
    }, 4500);

    // Brief pause on the tagline/CTA, then slide the hero away to reveal
    // the Most Popular grid sitting underneath.
    later(function () {
      el.classList.add('is-leaving');
    }, 5700);

    // Failsafe: regardless of whether any of the above animation stages
    // rendered correctly on this device/browser, force the overlay fully
    // out of the way so the real site is always reachable.
    later(function () {
      el.style.transition = 'none';
      el.style.transform = 'translateY(-100%)';
      el.style.pointerEvents = 'none';
      el.style.display = 'none';
      if (siteHeader) siteHeader.classList.add('is-visible');
    }, 7000);
  }

  whenFontsReady(runSequence);
})();
